export default __webpack_public_path__ + "static/media/Banner-2.c4b6ed75.jpg";